<template>
  <v-list class="py-0">
    <v-data-iterator 
      :search="$store.state.locationsearch" 
      :items="$store.state.streets_unique" 
      hide-actions>
      <template 
        slot="item" 
        slot-scope="props">
        <v-divider v-if="props.index !== 0" />
        <v-list-tile 
          v-if="!props.item.multiple" 
          xs12 
          @click="select(props.item)">
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              {{ props.item.name }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ props.item.account_name }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="props.item.selected">
            <v-icon color="info">check_circle</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-expansion-panel 
          v-else 
          class="expansion no-transition">
          <v-expansion-panel-content class="no-transition">
            <v-layout slot="header">
              <v-list class="py-0">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ props.item.street + ' ('+props.item.locations.length+' kohdetta)' }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ props.item.account_name }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list>
              <v-spacer/>
              <v-icon v-if="props.item.selected">check_circle</v-icon>
            </v-layout>
            <v-list class="py-0">
              <v-card-text>
                <template v-for="(item, index) in props.item.locations">
                  <v-divider 
                    v-if="index !== 0" 
                    :key="props.index+'divider'+index" />
                  <v-list-tile 
                    :key="item.index" 
                    @click="select(item)">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">
                        {{ item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ item.account_name }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="item.selected">
                      <v-icon color="info">check_circle</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-card-text>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
    </v-data-iterator>
  </v-list>
</template>
<script>
export default {
	methods: {
		select(item) {
			item.selected = true
			if (typeof item.parent !== 'undefined') {
				this.$store.state.streets_unique[item.parent].selected = true
			}
			this.$store.dispatch('create_cart', item)
			this.$store.state.locationdialog = false
			this.$store.state.locationsearch = ''
			if (this.$route.path == '/') this.$router.push('kohde')
		},
		close() {
			this.$store.state.locationdialog = false
		},
		blur(event) {
			event.target.blur()
		}
	}
}
</script>
<style>
.v-expansion-panel__body {
  transition: none !important;
}
</style>
